import { pick, values } from 'ramda';
import { composeC } from 'ramda-extension';

export const pickValues = composeC(values, pick);
